import {
    Component,
    computed,
    inject,
    input,
    ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { sanitizeTrustedHtml } from '../../utils/sanitize-trusted-html';

@Component({
    selector: 'apcam-rich-text-renderer',
    templateUrl: './rich-text-renderer.component.html',
    styleUrl: './rich-text-renderer.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class RichTextRendererComponent {
    readonly html = input<string | null | undefined>();
    readonly class = input<string | undefined>();

    private readonly sanitizer = inject(DomSanitizer);

    protected readonly sanitizedHtml = computed((): string | null => {
        const value = this.html()?.trim();
        if (!value) {
            return null;
        }

        return sanitizeTrustedHtml(this.sanitizer, value);
    });
}
